import React from "react";
import ExternalLinkWrapper from "@/components/common/external-link-wrapper";

export default function GetStartedButton({ affiliateLink, companyName, eventSource = "reviews" }) {
  if (!affiliateLink) return null;

  return (
    <ExternalLinkWrapper
      sourceId={`get_started_from_${eventSource}`}
      name={companyName}
      className="block w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg text-center transition-colors duration-200"
    >
      <span>Get started now!</span>
    </ExternalLinkWrapper>
  );
}
